import { render, staticRenderFns } from "./IndexHead.vue?vue&type=template&id=7922924a&scoped=true&"
import script from "./IndexHead.vue?vue&type=script&lang=js&"
export * from "./IndexHead.vue?vue&type=script&lang=js&"
import style0 from "./IndexHead.vue?vue&type=style&index=0&id=7922924a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7922924a",
  null
  
)

export default component.exports